import Parcel from './parcel';


export default Parcel;

export {
    Parcel
}